'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalCheckoutDeliveryInfoComponent = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rentalCheckoutDeliveryInfoComponent = exports.rentalCheckoutDeliveryInfoComponent = {
    template: require('./rental-checkout-delivery-info.html'),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        onContactInfoChange: '&',
        onDeliveryInfoChange: '&',
        onFormChange: '&',
        onCityChange: '&',
        formReference: '<'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", "$timeout", function controller(rentalProductsService, $timeout) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.changeTelephoneNumber = changeTelephoneNumber;
        vm.changeContactPerson = changeContactPerson;
        vm.changeCity = changeCity;
        vm.changeBox = changeBox;
        vm.changeHouseNumber = changeHouseNumber;
        vm.changeStreetName = changeStreetName;
        vm.checkForBackSpace = checkForBackSpace;
        vm.changeRemark = changeRemark;
        vm.changeDate = changeDate;
        vm.searchStreet = searchStreet;
        vm.searchCities = searchCities;
        vm.formchange = formchange;
        vm.citySearchString = vm.deliveryInfo.cityName ? vm.deliveryInfo.cityName : '';
        vm.streetSearchString = vm.deliveryInfo.streetName ? vm.deliveryInfo.streetName : '';

        function init() {
            var minDate;
            if (vm.rentalProduct.deliveryByExternalPartner) {
                if ((0, _moment2.default)().isoWeekday() === 5 || (0, _moment2.default)().isoWeekday() === 6) {
                    minDate = (0, _moment2.default)().add(3, 'days');
                } else {
                    minDate = (0, _moment2.default)().add(2, 'days');
                }
            } else {
                minDate = (0, _moment2.default)().add(1, 'days');
            }
            vm.fromDate = minDate.toISOString();
            vm.maxDate = (0, _moment2.default)().add(1, 'months').toISOString();
            vm.deliveryInfo.deliveryDate ? null : vm.deliveryInfo.deliveryDate = minDate; //if there is no deliveryDate, set a default
        }

        $timeout(function () {
            vm.formchange(); //hack to trigger validation when going to the previous page
        });

        function searchCities(query) {
            vm.deliveryInfo.postalLocalityId = 0;
            vm.deliveryInfo.cityName = '';
            vm.deliveryInfo.postalCode = '';
            vm.streetSearchString = '';
            vm.deliveryInfo.streetName = '';
            vm.deliveryInfo.streetId = 0;
            vm.formchange();
            return rentalProductsService.searchCities(query);
        }

        function searchStreet(query) {
            vm.deliveryInfo.streetName = '';
            vm.deliveryInfo.streetId = 0;
            vm.formchange();
            return rentalProductsService.searchStreet(query, vm.deliveryInfo.postalLocalityId);
        }

        function formchange() {
            vm.onFormChange();
        }

        function changeDate($event) {
            vm.deliveryInfo.deliveryDate = $event;
            this.onDeliveryInfoChange({ $event: vm.deliveryInfo });
            vm.formchange();
        }

        function changeCity(item) {
            vm.deliveryInfo.postalLocalityId = item.id;
            vm.deliveryInfo.cityName = item.name;
            vm.deliveryInfo.postalCode = item.postalCode;
            this.onDeliveryInfoChange({ $event: vm.deliveryInfo });
            vm.formchange();
        }

        function checkForBackSpace(event) {
            if (event.keyCode === 8) {
                vm.deliveryInfo.streetId = 0;
            }
            vm.formchange();
        }

        function changeStreetName(item) {
            vm.deliveryInfo.streetName = item.name;
            vm.deliveryInfo.streetId = item.id;
            this.onDeliveryInfoChange({ $event: vm.deliveryInfo });
            vm.formchange();
        }

        function changeBox(deliveryInfo) {
            this.onDeliveryInfoChange({ $event: deliveryInfo });
            vm.formchange();
        }

        function changeHouseNumber(deliveryInfo) {
            this.onDeliveryInfoChange({ $event: deliveryInfo });
            vm.formchange();
        }

        function changeRemark(deliveryInfo) {
            this.onDeliveryInfoChange({ $event: deliveryInfo });
            vm.formchange();
        }

        function changeContactPerson(contactInfo) {
            this.onContactInfoChange({ $event: contactInfo });
            vm.formchange();
        }

        function changeTelephoneNumber(contactInfo) {
            this.onContactInfoChange({ $event: contactInfo });
            vm.formchange();
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-checkout-delivery-info.js
// module id = 990
// module chunks = 0